import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    padding: theme.spacing(20, 16),
    backgroundColor: theme.palette.mono.lightGray,
    color: theme.palette.mono.primaryDark,
    flex: 1,
  },
  title: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.h5.fontWeight,
    marginBottom: theme.spacing(2),
  },
  content: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
  },
  divider: {
    backgroundColor: theme.palette.mono.gray,
    height: "4px",
    width: "60px",
    borderRadius: "100px",
    margin: theme.spacing(4, 0),
  },
}));

export interface EmptyListProps {
  title: string;
  emptyMessage: React.ReactElement | string;
  resetMessage: React.ReactElement | string;
}

const EmptyList = ({ title, emptyMessage, resetMessage }: EmptyListProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.content}>{emptyMessage}</Typography>
      <Box className={classes.divider} />
      <Typography className={classes.content}>{resetMessage}</Typography>
    </Box>
  );
};

export default EmptyList;
